// Central site configuration. Edit this file to update business info.
export const SITE = {
  name: "Tia Sandra Pet Care",
  tagline: "Cuidar do seu pet é um ato de amor",
  phone: "(47) 98420-4643",
  whatsappNumber: "5547984204643", // international format used in wa.me link
  whatsappMessage:
    "Olá Tia Sandra! Gostaria de agendar um atendimento para meu pet 🐾",
  instagram: "@tia_sandrapetcare",
  instagramUrl: "https://instagram.com/tia_sandrapetcare",
  address: "Rua Paraguai, 90 — Ponta Aguda (Anexo à AABB), Blumenau - SC",
  city: "Blumenau - SC",
  hours: [
    { day: "Segunda a Sexta", time: "08h00 — 19h00" },
    { day: "Sábado", time: "08h00 — 17h00" },
    { day: "Domingo", time: "Fechado" },
  ],
  mapsEmbed:
    "https://www.google.com/maps?q=Rua+Paraguai,+90+-+Ponta+Aguda,+Blumenau+-+SC&output=embed",
};

export const waLink = (msg) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
    msg || SITE.whatsappMessage
  )}`;
